import React from "react";
import { useGetPanelScoutUsersQuery } from "../endpoints/panel-scout-users.endpoints";
import PanelScoutUsersTable from "../components/users/panel-scout-users-table";

const UsersTab: React.FC = () => {
  const { data: users = [], isLoading, isError } = useGetPanelScoutUsersQuery();

  return (
    <div className="h-full overflow-y-auto">
      <p className="text-sm text-gray-500 mb-4">
        Manage and view Panel Scout users.
      </p>
      {isLoading ? (
        <div className="py-12 text-center text-gray-500">
          Loading users…
        </div>
      ) : isError ? (
        <div className="py-12 text-center text-red-600">
          Failed to load users. Please try again.
        </div>
      ) : (
        <PanelScoutUsersTable users={users} />
      )}
    </div>
  );
};

export default UsersTab;
